import { DelegationCallbacks } from 'inter-extension-control/module/src/delegationListener';
import { onNewDelegationVerdict } from './delegationVerdict';
import { shouldBlockByTime } from '../navigation/verdict';
import { loginWithDelegation, logoutDelegation } from './login';
import {
  isDelegationActive,
  isLoggedInWithDelegation,
  updateDelegation,
} from './delegation';

/**
 * Delegation callbacks implementation
 */
export const delegationCallbacks: DelegationCallbacks = {
  /**
   * Is logged-in action received
   */
  onIsLoggedIn: async () => isLoggedInWithDelegation(),

  /**
   * Login action received
   */
  onLogin: async (token: string) => {
    console.log(`Logging in with token=${token}`);
    return loginWithDelegation(token);
  },

  /**
   * Logout action received
   */
  onLogout: () => {
    console.log('Logging out...');
    return logoutDelegation();
  },

  /**
   * Is delegation active action received
   */
  onIsDelegationActive: isDelegationActive,

  /**
   * Send verdict action received
   */
  onSendVerdict: onNewDelegationVerdict,

  /**
   * Should ignore Safety Net action received
   */
  onShouldIgnoreSafetyNet: async () => !!shouldBlockByTime(),

  /**
   * Start delegation action received
   */
  onStartDelegation: () => {
    console.info('Starting delegation...');
    return updateDelegation('START');
  },

  /**
   * Stop delegation action received
   */
  onStopDelegation: () => {
    console.info('Stopping delegation...');
    return updateDelegation('STOP');
  },
};
